import {
	useTypedLazyQuery,
	useTypedMutation,
	useTypedQuery,
} from "@/services/graphApi";
import { $, ValueTypes, ZeusSelect } from "@/services/graphApi/graphql-zeus";

export const useHarvestAccessesQuery = () =>
	useTypedQuery(
		{
			harvestAccesses: [
				{
					where: {
						organizationAttributes_some: {
							organization: { id: $`organizationId` },
						},
					},
				},
				HarvestAccessSelector,
			],
		},
		{
			notifyOnNetworkStatusChange: true,
		}
	);

export const useHarvestAccessesLazyQuery = () =>
	useTypedLazyQuery(
		{
			harvestAccesses: [
				{
					where: {
						organizationAttributes_some: {
							organization: { id: $`organizationId` },
						},
					},
				},
				HarvestAccessSelector,
			],
		},
		{
			notifyOnNetworkStatusChange: true,
		}
	);

export const useHarvestAccessQuery = () =>
	useTypedLazyQuery(
		{
			harvestAccess: [
				{
					where: {
						id: $`id`,
					},
				},
				HarvestAccessSelector,
			],
		},
		{
			notifyOnNetworkStatusChange: true,
		}
	);

export const useCreateHarvestAccess = () => {
	return useTypedMutation({
		createHarvestAccess: [
			{
				data: $`data`,
			},
			HarvestAccessSelector,
		],
	});
};
export const useUpdateHarvestAccess = () => {
	return useTypedMutation({
		updateHarvestAccess: [
			{
				where: $`where`,
				data: $`data`,
			},
			HarvestAccessSelector,
		],
	});
};
export const useDeleteHarvestAccess = () => {
	return useTypedMutation({
		deleteHarvestAccess: [
			{
				where: $`where`,
			},
			HarvestAccessSelector,
		],
	});
};

export const HarvestAccessSelector = ZeusSelect<ValueTypes["HarvestAccess"]>()({
	id: true,
	descriptiveName: true,
	accountId: true,
	token: true,
	organizationAttributes: [
		{},
		{
			id: true,
			organization: {
				id: true,
				name: true,
			},
			role: true,
		},
	],
});
